var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "container-fluid mr-lateness-dashboard-container",
      style: _vm.containerStyles,
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "top",
            "label-width": "8em",
            inline: true,
            size: "mini",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "w-100" },
                    [
                      _c("el-date-picker", {
                        staticClass: "w-100",
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: false,
                          "start-placeholder": _vm.$t("dateRange.startDate"),
                          "end-placeholder": _vm.$t("dateRange.endDate"),
                          "picker-options": { firstDayOfWeek: 7 },
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getData("data")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: "search",
                              "aria-hidden": "true",
                              size: "sm",
                            },
                          }),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("general.search"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "lateness-dashboard" },
            [
              _c(
                "el-table",
                {
                  ref: "loadPlanTable",
                  staticClass: "mt-3",
                  attrs: {
                    size: "mini",
                    height: _vm.tableHeight,
                    border: "",
                    data: _vm.reportData,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { fixed: "", type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.route"),
                      prop: "projectCode",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.tooltip.cycle"),
                      width: "50",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.helper.isNotEmpty(scope.row.cycle)
                                      ? scope.row.cycle
                                      : "1"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      27022394
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("truck.plateNum"),
                      prop: "plateNumber",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.tooltip.driver"),
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getDriverInfo(
                                      scope.row.driverId,
                                      "UserName"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4219139507
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("planning.waypoint"), width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.companyName
                                      ? scope.row.companyName.toUpperCase()
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1375877239
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.gMap.type"),
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "planning.waypointType." +
                                        scope.row.waypointType
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1601338963
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("planning.planned"), width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.waypointType === "P" ||
                              scope.row.waypointType === "D"
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("planning.tooltip.eta")) +
                                        ": " +
                                        _vm._s(scope.row.estimateTime) +
                                        " "
                                    ),
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("planning.tooltip.end")) +
                                        ": " +
                                        _vm._s(scope.row.endTime) +
                                        " "
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      895724750
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("planning.actual"), width: "250" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.waypointType === "P" ||
                              scope.row.waypointType === "D"
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("planning.tooltip.eta")) +
                                        ": " +
                                        _vm._s(
                                          scope.row.actualData.estimateTime
                                        ) +
                                        " "
                                    ),
                                    _vm.isETAEarlyLate(scope.row)
                                      ? _c("span", [
                                          _vm._v(
                                            " (" +
                                              _vm._s(
                                                _vm.helper.secondsToHms(
                                                  scope.row.actualData
                                                    .runningTimeDifference
                                                )
                                              ) +
                                              ") "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("planning.tooltip.end")) +
                                        ": " +
                                        _vm._s(scope.row.actualData.endTime) +
                                        " "
                                    ),
                                    _vm.isEndTimeEarlyLate(scope.row)
                                      ? _c("span", [
                                          _vm._v(
                                            " (" +
                                              _vm._s(
                                                _vm.helper.secondsToHms(
                                                  scope.row.actualData
                                                    .endRunningTimeDifference
                                                )
                                              ) +
                                              ") "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2408460971
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("general.reason") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              (scope.row.waypointType === "P" ||
                                scope.row.waypointType === "D") &&
                              _vm.isEstimateReasonLate(scope.row)
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "planning.etaDiscrepancyReason"
                                          )
                                        ) +
                                        ": " +
                                        _vm._s(
                                          scope.row.actualData.estimateReason
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              scope.row.waypointType === "T" &&
                              _vm.isEndReasonLate(scope.row)
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "planning.endTimeDiscrepancyReason"
                                          )
                                        ) +
                                        ": " +
                                        _vm._s(scope.row.actualData.endReason) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2520144696
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("countdown", {
        ref: "countdown",
        attrs: { defaultRefreshTime: _vm.refreshTime },
        on: { onCountdownZero: _vm.handleCountdownZero },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }